import { useSearchIAStore } from '@/modules/documentSearcher/stores/useSearchIAStore'
import { FilterTypes } from '@/modules/documentSearcher/types/SearchIATypes'
import type { FilterType } from '@/modules/documentSearcher/types/SearchIATypes'
import { URLS } from '@/router/routes/urlRoutes'
import { router } from '@/router/router'

interface GoToIASearchParams {
  filterType: FilterType
  filterValue: any
  filterEntityName: string
}

export function useGoToIASearch() {
  const searchIAStore = useSearchIAStore()

  const goToIASearch = (params?: GoToIASearchParams) => {
    if (params) {
      searchIAStore.setFilter(params.filterType, params.filterValue, params.filterEntityName)
    }

    router.push({ name: URLS.SEARCH_IA })
  }

  const goToIASearchWithExpedient = (expedientData: any) => {
    if (expedientData) {
      goToIASearch({
        filterType: FilterTypes.EXPEDIENT,
        filterValue: expedientData.idOwnFile || null,
        filterEntityName: expedientData.idOwnFile || ''
      })
    } else {
      goToIASearch()
    }
  }

  const goToIASearchWithContact = (contactData: any, entityId?: number | string) => {
    console.log('goToIASearchWithContact', contactData, entityId)
    if (contactData) {
      const contactId = contactData.id || entityId
      const contactFullName = [contactData.name, contactData.firstSurname, contactData.secondSurname]
        .filter(Boolean)
        .join(' ')

      goToIASearch({
        filterType: FilterTypes.CONTACT,
        filterValue: contactId,
        filterEntityName: contactFullName || ''
      })
    } else {
      goToIASearch()
    }
  }

  return {
    goToIASearch,
    goToIASearchWithExpedient,
    goToIASearchWithContact
  }
}
